module.exports = __webpack_public_path__ + "img/add-new-send-light.9133bddd.svg";